import React, { useEffect } from "react";
import VideoGallery from "../../components/video-gallery/VideoGallery";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";

function VideoGalleryPage({ setShow }) {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>Video Gallery | Vinca Horticulture & Landscaping</title>
        <meta name="keyword" content="Vinca Horticulture & Landscaping" />
        <meta name="description" content="Vinca Horticulture & Landscaping" />
      </Helmet>
      <Breadcrumb title="Video Gallery" t={t} />
      <VideoGallery />
    </>
  );
}

export default VideoGalleryPage;
